import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ConfirmModal from '../../ConfirmModal';
import '../FeedbackHistory.scss';

const shorten = (text) => (text.length > 56 ? `${text.slice(0, 56)}...` : text);

const editableStatuses = ['Interviewed', 'Hired', 'Declined'];

class FeedbackHistoryRow extends Component {
  renderEdit() {
    const {
      item,
      proposalResourceId,
      csrfToken,
      consultant,
      reasonOptions,
      type,
    } = this.props;

    return (
      <ConfirmModal
        proposalResourceId={proposalResourceId}
        csrfToken={csrfToken}
        consultantName={consultant.name}
        type={type}
        reasonOptions={reasonOptions}
        modalTriggerCopy="Edit"
        modalTriggerType="button"
        buttonType="btn-secondary"
        statusChangeId={item.id}
        isEditing
      />
    );
  }

  renderViewClorify() {
    const { clorifyUrl } = this.props;

    return (
      <a
        role="button"
        target="_blank"
        tabIndex={0}
        id="view-clorify-button"
        href={clorifyUrl}
        rel="noreferrer"
      >
        View Clorify
      </a>
    );
  }

  renderStatus() {
    const { status } = this.props;

    return (
      <div className={`rounded-rectangle status-${status.split(' ').join('_').toLowerCase()}`}>
        <div className="status">{status}</div>
      </div>
    );
  }

  render() {
    const {
      item, status, internalFeedbackText, advisorRemark,
    } = this.props;

    let text;
    if (status === 'Submitted' && advisorRemark) {
      text = shorten(advisorRemark);
    } else if (item.change_reason) {
      text = shorten(item.change_reason);
    } else if (status === 'Drafting' && internalFeedbackText) {
      text = shorten(internalFeedbackText);
    } else {
      text = '';
    }

    return (
      <tr>
        <td colSpan="4">{text}</td>
        <td colSpan="2">{this.renderStatus()}</td>
        <td colSpan="2">{item.user_name}</td>
        <td colSpan="2">{item.created_at}</td>
        <td colSpan="2">{editableStatuses.includes(status) && this.renderEdit()}</td>
        <td colSpan="2">{this.renderViewClorify()}</td>
      </tr>
    );
  }
}

FeedbackHistoryRow.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  proposalResourceId: PropTypes.string.isRequired,
  consultant: PropTypes.shape({}).isRequired,
  clorifyUrl: PropTypes.string.isRequired,
  reasonOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  item: PropTypes.shape({}).isRequired,
  type: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  internalFeedbackText: PropTypes.string,
  advisorRemark: PropTypes.string,
};

FeedbackHistoryRow.defaultProps = {
  internalFeedbackText: null,
  advisorRemark: null,
};

export default FeedbackHistoryRow;
